import { LitElement, html, css,TemplateResult } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import '../../voyage-popup/src/voyage-popup';
import './voyage-dialog-popup-body-warning';

@customElement('voyage-dialog-popup')
export class VoyageDialogPopup extends LitElement
{
    @property({ type: String, attribute: "header-text" }) headerText: string = "";
    @property({ type: String, attribute: "body-text" }) bodyText: string = "";
    @property({ attribute: false }) bodyContent: TemplateResult | HTMLElement | null = null;
    @property({ type: Boolean, attribute: "is-error" }) isError: boolean = false;
    @property({ type: String }) errorDetails: string = "";
    @property({ type: String, attribute: "accept-button-text" }) acceptButtonText: string = "OK";
    @property({ type: Boolean, attribute: "no-accept-button" }) noAcceptButton: boolean = false;
    @property({ type: String, attribute: "reject-button-text" })  rejectButtonText: string = "";
    @property({ type: Boolean, attribute: "no-close-button" }) noCloseButton: boolean = false;

    static get styles() {
        return [
            css`
            :host {
            }

            .main {
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .errorIcon {
                margin: 40px;
                margin-top: 25px;
            }

            .errorIcon > svg {
                fill: var(--voyage-error-red, red);
                width: 40px;
            }

            .body {
                margin: 40px;
                margin-top: 25px;
                margin-bottom: 20px;
                color: var(--neutrals-grey-02, black);
                font-family: MaerskText;
                font-size: 14px;
                text-align: center;
                white-space: pre-line;
            }

            .body[is-error] {
                margin-top: 0px;
            }

            .errorDetails {
                box-sizing: border-box;
                margin: 40px;
                margin-top: 0;
                padding: 20px;
                border: 1px solid var(--warning-yellow-8, yellow);
                border-radius: 3px;
                background-color: rgba(var(--warning-yellow-10-rgb, yellow), 0.63);
                max-width: 635px;
                text-align: center;
                font-family: MaerskText;
                font-size: 14px;
                color: var(--neutrals-grey-02, black);
                white-space: pre-line;
            }
        `];
    }

    render()
    {
        return html`
            <voyage-popup shown header-text=${this.headerText} accept-button-text=${this.acceptButtonText} reject-button-text=${this.rejectButtonText} .noCloseButton=${this.noCloseButton} .noAcceptButton=${this.noAcceptButton}>
                ${ this.bodyContent ? this.bodyContent : this._defaultContent()}
            </voyage-popup>
        `;
    }

    firstUpdated()
    {
        this._popup = this.shadowRoot!.querySelector('voyage-popup');
        this._popup!.addEventListener('accept', () => this.remove() );
        this._popup!.addEventListener('close', () => this.remove() );
    }

    async getResponse(): Promise<"accept"|"reject">
    {
        if (!this._popup)
        {
            await this.updateComplete;
        }

        return new Promise( resolve => {
            this._popup!.addEventListener('accept', () => resolve('accept'), {once: true});
            this._popup!.addEventListener('close', () => resolve('reject'), {once: true});
        });
    }

    private _popup: HTMLElement|null = null;

    private _defaultContent() {
        return (
            html`
                <div class="main">${ this.isError ? html`<div class="errorIcon">${SvgIcons.lightExclamationTriangle}</div>` : html``}
                    <div class="body" ?is-error=${this.isError}>${this.bodyText}</div>
                    ${ this.errorDetails ? html`
                        <div class="errorDetails">
                            ${this.errorDetails}
                        </div>
                    `:html``}
                </div>`
        )
    }
}
